import { render, staticRenderFns } from "./MaterialsAdminPage.vue?vue&type=template&id=d9364a3e&scoped=true&"
import script from "./MaterialsAdminPage.vue?vue&type=script&lang=js&"
export * from "./MaterialsAdminPage.vue?vue&type=script&lang=js&"
import style0 from "./MaterialsAdminPage.vue?vue&type=style&index=0&id=d9364a3e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d9364a3e",
  null
  
)

export default component.exports